import './SignUpTitle.css';
import {isMobile} from 'react-device-detect';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const SignUpTitle = (props) => {
  const navigate = useNavigate();
  const { stepNumber } = props;
  let pageName = "";
  switch (stepNumber) {
    case 1:
      pageName = "Company Information";
      break;
    case 2:
      pageName = "Contact Information";
      break;
    case 3:
      pageName = "Payment Information";
      break;
    default:
      pageName = "Company Information";
      break;
  }

  const renderProgress = (step) => {
    const elements = [];
    for (let i = 1; i <= 3; i++) {
      elements.push(
        <div key={`circle-${i}`} className={i <= step ? 'blueCir' : 'grayCir'}></div>
      );
      if (i < 3) {
        elements.push(
          <div key={`line-${i}`} className={i < step ? 'blueLine' : 'grayLine'}></div>
        );
      }
    }
    return elements;
  };

  return (
    <div className='sign-container'>
      <div className='signup-title-header'>
        {(isMobile && stepNumber === 1)? (
          <Button 
            variant="signup-title" 
            className='signup-title-back-button' 
            onClick={() => navigate('/Login')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-left-fill" viewBox="0 0 16 16">
              <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
            </svg>
          </Button>
        ) : null}
        <div className='first-line'>Create a Voyce Account</div>
      </div>
      <div className='second-line'>STEP {stepNumber} of 3</div>
      <div className='third-line'>{pageName}</div>
      <div id="cirLine">
        {renderProgress(stepNumber)}
      </div>
    </div>
  );
};


export default SignUpTitle;
